import React from "react";

/**
 * Reusable KpiCard component.
 *
 * Props:
 *  - title: string              — card label (e.g. "Total Users")
 *  - value: string | number     — main displayed value
 *  - subtitle?: string          — small text below value (e.g. "across 4 items")
 *  - trend?: number             — percentage change (positive = up, negative = down)
 *  - icon: React.ReactNode      — icon element
 *  - iconBgColor?: string       — background of icon box (default "#EEF2FF")
 *  - iconColor?: string         — icon stroke/fill color (default "#6366F1")
 */
const KpiCard = ({
    title,
    value,
    subtitle,
    trend,
    icon,
    iconBgColor = "#EEF2FF",
    iconColor = "#6366F1",
}) => {
    const isPositive = trend >= 0;

    return (
        <div className="kpi-card">
            <div className="kpi-card-header">
                <div className="kpi-card-icon" style={{ backgroundColor: iconBgColor, color: iconColor }}>
                    {icon}
                </div>
            </div>

            <div className="kpi-card-content">
                <p className="kpi-card-title">{title}</p>
                <h3 className="kpi-card-value">{value}</h3>
                {subtitle && <p className="kpi-card-subtitle">{subtitle}</p>}
            </div>
        </div>
    );
};

export default KpiCard;
